export const WORLD_MAP_GEO_URL =
  'https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json';

export const WORLD_MAP_WIDTH = 800;
export const WORLD_MAP_HEIGHT = 400;

export const WORLD_MAP_PROJECTION_CONFIG = {
  scale: 150,
  center: [10, 8] as [number, number],
};
